import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/super_menu'

export const initialState = fromJS({
  showInterfaces: false,
  showSuppliers: false,
  showNewsIds: false
})

export default handleActions({
  [Actions.setShowInterfaces]: (state, { payload: value }) => state.set('showInterfaces', value),
  [Actions.setShowSuppliers]: (state, { payload: value }) => state.set('showSuppliers', value),
  [Actions.setShowNewsIds]: (state, { payload: value }) => state.set('showNewsIds', value)
}, initialState)
